import styled, { keyframes } from 'styled-components'
import { Container, ContainerContent } from 'components/Containers/Containers'
import { tokens } from 'styling/tokens'

export const HeaderLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  flex: none;
  padding: 0;
  border: none;
  background: transparent;
  font-size: ${tokens.font.label};
  font-weight: 500;
  color: ${tokens.accent.onDark};
  cursor: pointer;
  transition: color ${tokens.motion.duration} ${tokens.motion.ease};

  &:hover {
    color: ${tokens.accent.base};
  }
`

export const InvKpiStrip = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(11rem, 1fr));
  gap: 0.75rem;
  margin-bottom: 1rem;
`

export const KpiWarnText = styled.span`
  color: ${tokens.status.warning.fg};
`

export const InvGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 1rem;
  align-items: stretch;
`

export const InvWidget = styled(Container)<{ $span: number }>`
  grid-column: span ${(props) => props.$span};
  display: flex;
  flex-direction: column;
  min-width: 0;

  @media (max-width: 1240px) {
    grid-column: span ${(props) => (props.$span >= 8 ? 12 : 6)};
  }

  @media (max-width: 860px) {
    grid-column: span 12;
  }
`

export const WidgetBody = styled(ContainerContent)`
  flex: 1;
  min-height: 0;
  max-height: 19rem;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: thin;
  scrollbar-color: ${tokens.border.strong} transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: ${tokens.border.strong};
    border-radius: 999px;
  }
`

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const WidgetLoader = styled.div`
  width: 2rem;
  height: 2rem;
  border: 3px solid ${tokens.accent.soft};
  border-top-color: ${tokens.accent.base};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`

export const ReorderTableTight = styled.div`
  width: 100%;

  th,
  td {
    padding: 0.5rem;
  }

  td:first-child {
    max-width: 0;
    overflow: hidden;
  }

  th:last-child,
  td:last-child {
    width: 1%;
    white-space: nowrap;
    padding-right: 0.625rem;
  }
`

export const ItemCellText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 0;
`

export const ItemCellName = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const ItemCellMeta = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
  font-variant-numeric: tabular-nums;
`

export const DaysText = styled.span<{ $color: string }>`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${(props) => props.$color};
  font-variant-numeric: tabular-nums;
`

export const CriticalRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.375rem 0;
  border-bottom: 1px solid ${tokens.border.hairline};

  &:last-child {
    border-bottom: none;
  }
`

export const CriticalNums = styled.span`
  flex: none;
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
  font-variant-numeric: tabular-nums;
`

export const LocationRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.375rem 0;
  border-bottom: 1px solid ${tokens.border.hairline};

  &:last-child {
    border-bottom: none;
  }
`

export const LocationTopLine = styled.div`
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
`

export const LocationName = styled.span`
  flex: 1;
  min-width: 0;
  font-size: ${tokens.font.body};
  color: ${tokens.text.primary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const LocationValue = styled.span`
  flex: none;
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
  font-variant-numeric: tabular-nums;
`

export const LocationMeta = styled.span`
  flex: none;
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
  font-variant-numeric: tabular-nums;
`

export const BarTrack = styled.div`
  width: 100%;
  height: 0.45rem;
  border-radius: 999px;
  background: ${tokens.surface.inset};
  overflow: hidden;
`

export const BarFill = styled.div<{ $pct: number }>`
  height: 100%;
  width: ${(props) => props.$pct}%;
  border-radius: 999px;
  background: ${tokens.accent.base};
  transition: width 0.5s ${tokens.motion.ease};
`
